import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PostService } from '../services/post.service';
import { Doddle } from '../models';
import { map, of } from 'rxjs';

export const doddleResolver: ResolveFn<Doddle | null> = (route, state) => {
  const postService = inject(PostService);
  const doddleId = route.paramMap.get('doddleId');
  if (!doddleId) {
    return of(null);
  }

  const doddle = postService
    .getDoddleById(doddleId)
    .pipe(map((doddle) => doddle));

  return doddle;
};
